export default __webpack_public_path__ + "static/media/lush4.f2e9f209.png";